import { Box, Button, ButtonBase, Grid, Link, List, ListItem, ListItemText, Typography, alpha, useTheme } from "@mui/material"
import { useState } from "react";
import styles from "./FipDiscoveredAccountsSection.styles";
import AddNumber from "../AddNumber";
import NotFoundHeading from "./NotFoundHeading";
import FipdNotDiscovered from "./FipdNotDiscovered";
import sizeFontCustom from "./fontSize.styles"
import { useTranslation } from "../../hooks/useTranslation";

function FipNotDiscoveredAccountsSection(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const fipIds = props?.accountState?.noDiscoveredAccounts?.fips;
  const phoneNumber = props?.accountState?.noDiscoveredAccounts?.phoneNumber
  
  // Check for dark theme
  const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
  const [showChangeNumber, setShowChangeNumber] = useState(false)
  const [expandedExplanation, setExpandedExplanation] = useState(false)
  const handleChangeNumber = () => {
    props.setChangingMobileNumber(true)
    setShowChangeNumber(true)
  }
  const toggleAcordion = () => {
    setExpandedExplanation((prev) => !prev);
  };

  return (
    <Grid item
      xs={12}
      sm={8}
      md={8}
      lg={5.5}
    >
      <List sx={{
        background: isDark ? '#2D2D2D' : theme.palette.primary.white,
        color: isDark ? '#FFFFFF' : '#000000',
        justifyContent: "start",
        alignItems: "start",
        padding: "0.5rem",
        borderRadius: "1rem",
        border: 'none',
      }}>
        <NotFoundHeading />
        {!showChangeNumber &&
          <Box>
            <ListItem sx={{ pt: '0.125rem' }}>
              <ListItemText
                primary={
                  <Box ml={"1rem"}>
                  <Typography
                    sx={sizeFontCustom.subHeading}
                    color={isDark ? '#7A8185' : theme.palette.black60}>
                    {t('accountDiscovery.messages.couldNotFindAccounts')}
                    <span
                      style={{ color: isDark ? '#FFFFFF' : theme.palette.info.main, fontWeight: 700 }}
                    >
                      {" " + phoneNumber + ". "}
                    </span>
                    </Typography>
                  {global.sdkOptions?.allowDifferentMobile === "Y" &&
                  <ButtonBase
                    disabled={props.changingMobileNumber}
                    onClick={handleChangeNumber}
                    sx={{ 
                      color: isDark ? '#FFFFFF' : theme.palette.primary.main, 
                      cursor: "pointer", 
                      textDecoration: "none", 
                      fontWeight: "700", 
                      textTransform: "capitalize", 
                      ...sizeFontCustom.subHeading, 
                      mt:".5rem",
                      '&:hover': {
                        color: isDark ? '#7A8185' : theme.palette.primary.main,
                      }
                    }}
                  >
                     {t('common.buttons.changeMobileNumber')}
                  </ButtonBase>}</Box>}
                secondary={
                  <>
                    <Grid
                      container
                      sx={{
                        ...styles.fipNotFoundContainer,
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.5),
                          borderRadius: "10px",
                        }
                      }}
                    >
                      {fipIds.map((fipId) => <FipdNotDiscovered key={fipId} fipId={fipId} />)}
                    </Grid>
                    <Box>
                      <Link
                        underline="none"
                        display={!expandedExplanation ? "block" : "none"}
                        onClick={toggleAcordion}
                        sx={{ 
                          cursor: "pointer", 
                          ...sizeFontCustom.subHeading, 
                          mt: "0.8rem",
                          color: isDark ? '#FFFFFF' : 'primary',
                        }}
                      >
                        {t('accountDiscovery.errors.moreInfo')}
                      </Link>
                      {expandedExplanation &&
                        <>
                          <Typography
                            component="div"
                            py={"0.5rem"}
                            sx={{
                              ...sizeFontCustom.subHeading,
                              color: isDark ? '#FFFFFF' : 'inherit',
                            }}
                          >
                            {t('accountDiscovery.errors.dueToEither')}
                            <ul style={{
                              ...styles.list,
                              color: isDark ? '#FFFFFF' : 'inherit',
                            }}>
                              <li>{t('accountDiscovery.errors.technicalDifficulties')}</li>
                              <li>{t('accountDiscovery.errors.jointAccount')}</li>
                            </ul>
                          </Typography>
                          <Link
                            underline={'none'}
                            sx={{ 
                              cursor: "pointer", 
                              ...sizeFontCustom.subHeading,
                              color: isDark ? '#FFFFFF' : 'primary',
                            }}
                            onClick={toggleAcordion}
                          >
                            {t('common.buttons.showLess')}
                          </Link>
                        </>}
                          <Typography sx={{ 
                            mb: "0.8rem", 
                            ...sizeFontCustom.subHeading,
                            color: isDark ? '#FFFFFF' : 'inherit',
                          }}>
                            {t('accountDiscovery.errors.tryDiscovering')}
                          </Typography>
                    </Box>
                  </>
                }
              />
            </ListItem>
          </Box>}
        {global.sdkOptions?.allowDifferentMobile === "Y" &&
          (showChangeNumber &&

            <AddNumber {...props} fipSelect={fipIds} setShowChangeNumber={setShowChangeNumber} isComponent={true} />
          )
        }
      </List>
    </Grid>
  )
}

export default FipNotDiscoveredAccountsSection;
